
import { customGlobal } from "./global";
// import { io } from 'jsts/dist/jsts';

const strFieldTypes = ['varchar', 'string', 'text', 'char', 'clob'];
const dateFieldTypes = ['date', 'time'];
const numberFieldTypes = ['number', 'int'];

export let fieldHelper = {
    isString(fieldType) {
        return this.judge(fieldType, strFieldTypes);
    },
    isDate(fieldType) {
        return this.judge(fieldType, dateFieldTypes);
    },
    isNumber(fieldType) {
        return this.judge(fieldType, numberFieldTypes);
    },
    judge(fieldType, types) {
        for (let i = 0; i < types.length; i++) {
            if (fieldType.toLowerCase().indexOf(types[i]) > -1) {
                return true;
            }
        }
        return false;
    }
}

export let fileHelper = {
    downloadJson(json, filename) {
        let content = JSON.stringify(json);
        var eleLink = document.createElement('a');
        eleLink.download = filename;
        eleLink.style.display = 'none';
        // 字符内容转变成blob地址
        var blob = new Blob([content], { type: "text/plain;charset=utf-8" });
        eleLink.href = URL.createObjectURL(blob);
        // 触发点击
        document.body.appendChild(eleLink);
        eleLink.click();
        // 然后移除
        document.body.removeChild(eleLink);
    },
    base64ToFile(dataURI, type) {
        let binary = atob(dataURI.split(',')[1]);
        let array = [];
        for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], { type: type || 'image/jpeg' });
    }
}

export let fileTypeHelper = {
    types: [{
        type: 'picture',
        exts: ['.jpg', '.png', '.bmp', '.gif', 'ico']
    }, {
        type: 'excel',
        exts: ['.xls', '.xlsx']
    }, {
        type: 'word',
        exts: ['.doc', '.docx']
    }, {
        type: 'ppt',
        exts: ['.ppt', '.pptx']
    }, {
        type: 'pdf',
        exts: ['.pdf']
    }, {
        type: 'zip',
        exts: ['.zip', '.7z', '.rar']
    }, {
        type: 'exe',
        exts: ['.exe', '.apk']
    }, {
        type: 'video',
        exts: ['.mp4', '.avi', '.rmvb', '.mkv']
    }],
    getType(name) {
        let fileTypeObj = this.types.find(item => {
            for (let i = 0; i < item.exts.length; i++) {
                if ((name || '').toLowerCase().endsWith(item.exts[i])) {
                    return true;
                }
            }
            return false;
        });
        if (fileTypeObj) {
            return fileTypeObj.type;
        }
        return null;
    }
}

export let parseResultToJson = (data) => {
    let jsonResult = [];
    (data.result || []).forEach((item, i) => {
        let json = {};
        data.columns.forEach((column, j) => {
            json[column.name] = item[j];
        });
        jsonResult.push(json);
    });
    return jsonResult;
}

let buildColumnsByQueryResult = (result) => {

    let cols = [];

    let data = null;
    if (result instanceof Array) {
        if (!result.length)
            return cols;

        data = result[0];
    }

    if (data === null)
        data = result;

    if (data === null || data === undefined)
        return cols;

    let isAtom = false;
    if (typeof data !== "object") {
        data = { value: data };
        isAtom = true;
    }

    for (const key in data) {
        const element = data[key];
        const type = typeof element;
        const svg = getTypeIcon(type);
        const c = {
            name: key,
            alias: key,
            type: type,
            rawType: null,
            svg: svg,
            isAtom: isAtom,
            isNumber: isNumber(svg),
            isBool: isBool(svg),
            isString: isString(svg),
            isDateTime: isDateTime(svg),
            isGeometry: isGeometry(svg),
            isObject: isObject(svg),
        }
        c.typeAlias = getTypeAlias(c);
        c.getValue = getValue.bind(c);

        cols.push(c);
    }

    return cols;
}

let isNumber = (type) => {
    return type === "#anticon-sy-paas-field-number";
}

let isBool = (type) => {
    return type === "#anticon-sy-paas-field-boole";
}

let isString = (type) => {
    return type === "#anticon-sy-paas-field-short-text";
}

let isDateTime = (type) => {
    return type === "#anticon-sy-paas-field-datetime";
}

let isGeometry = (type) => {
    return type === "#anticon-sy-paas-field-address-management";
}

let isObject = (type) => {
    return type === "#anticon-sy-paas-field-department";
}

let getValue = function (data) {

    if (this.isAtom)
        return data;

    data = data[this.name];
    return data;
}

let getTypeIcon = (type) => {
    type = type.toLowerCase();
    if (type === "string" || type === "text")
        return "#anticon-sy-paas-field-short-text";
    if (type === "number" || type === "int32" || type === "int16" || type === "int64" || type === "byte" || type === "short" || type === "long" || type === "double" || type === "float")
        return "#anticon-sy-paas-field-number";
    if (type === "bool" || type === "boolean")
        return "#anticon-sy-paas-field-boole";
    if (type === "date" || type === "datetime" || type === "time" || type === "timestamp")
        return "#anticon-sy-paas-field-datetime";
    if (type === "geometry")
        return "#anticon-sy-paas-field-address-management";

    return "#anticon-sy-paas-field-department";
}

let getTypeAlias = (c) => {
    if (c.isNumber)
        return "数值";
    if (c.isBool)
        return "布尔";
    if (c.isString)
        return "字符串";
    if (c.isDateTime)
        return "时间";
    if (c.isGeometry)
        return "二维图形";
    if (c.isObject)
        return "对象";
}

export let parseQueryResultToCommonResult = (data) => {

    let result = null;
    let cols = [];

    if (data === null || data === undefined) {
        return {
            columns: cols,
            result: data,
        };
    }

    if (typeof data === "object" && "time" in data && "metaData" in data && "columns" in data && data.columns && data.columns.length) {
        cols = data.columns.map(c => {
            const svg = getTypeIcon(c.typeName);
            const col = {
                name: c.name,
                alias: c.label,
                type: c.typeName,
                rawType: c.rawTypeName,
                svg: svg,
                isNumber: isNumber(svg),
                isBool: isBool(svg),
                isString: isString(svg),
                isDateTime: isDateTime(svg),
                isGeometry: isGeometry(svg),
                isObject: isObject(svg),
            };
            col.typeAlias = getTypeAlias(col);
            col.getValue = getValue.bind(col);

            return col;
        });
        result = parseResultToJson(data);
    }
    else if (typeof data === "object" && "time" in data && "metaData" in data && "columns" in data && !data.columns) {
        result = data.result;
        cols = buildColumnsByQueryResult(result);
    }
    else {
        return parseQueryResultToCommonResult({
            columns: null,
            result: data,
            time: 1,
            metaData: null,
        });
    }

    // if (!cols.length)
    //     result = null;

    return {
        columns: cols,
        result: result,
    };
}

let helper = {
    dms2dec: (value) => {
        let splitStr = value.split("°");
        var du = splitStr[0];
        var fen = splitStr[1].split("'")[0];
        var miao = splitStr[1].split("'")[1].split('"')[0];

        return Math.abs(du) + (Math.abs(fen) / 60 + Math.abs(miao) / 3600);
    },
    decToDms: (value) => {
        value = Math.abs(value);
        var v1 = Math.floor(value);//度
        var v2 = Math.floor((value - v1) * 60);//分
        var v3 = Math.round((value - v1) * 3600 % 60);//秒
        return v1 + '°' + v2 + '\'' + v3 + '"';
    },
    getVersion: () => {
        let actuator = customGlobal.get('actuator');
        let version = null;
        if (actuator && actuator.app && actuator.app.publicVersion) {
            version = actuator.app.publicVersion;
        }
        return version;
    },
    loadJs: (key, url, callback) => {
        let id = `script-${key ? key : Math.random().toString().substring(3)}`;
        let fn = callback || function () { };
        let exist = document.getElementById(id);
        if (exist) {
            fn();
            return;
        }
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = id;
        //IE
        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState == 'loaded' || script.readyState == 'complete') {
                    script.onreadystatechange = null;
                    fn();
                }
            };
        } else {
            script.onload = function () {
                fn();
            };
        }
        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
    }
}
export default helper;

window.dms2dec = helper.dms2dec;